// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__-t7E9","title":"BackImages_title__2bo8s","images":"BackImages_images__27AeK"};